import React, { FC } from "react";

import TemplateDetail from "../../components/Template/TemplateDetail";

const TemplateDetailPage: FC = () => <TemplateDetail/>;

export default TemplateDetailPage;
